export default __webpack_public_path__ + "static/media/triple-02.54d6affc.png";